import { apiClient } from 'src/js/api';
import { rxTaskFactory } from 'src/js/helper/mobx-tasks';
import { SameTypeNetworkTaskGenerator } from 'src/js/util/global-type';

export const createLogoutTask: SameTypeNetworkTaskGenerator<unknown> = () =>
  rxTaskFactory(() => apiClient.sessionController.logout());
